const notLogRouter = [

    {
        "id": 1,
        "parentId": 0,
        "menuName": "云开发",
        "path": "/cloud",
        "component": null,
        "perms": "cloud",
        "icon": "#",
        "menuType": "M",
        "orderNum": 1,
        "children": []
    },
    {
        "id": 5,
        "parentId": 0,
        "menuName": "首页",
        "path": "/home",
        "component": "views/homePage/HomePage.vue",
        "perms": "home",
        "icon": "#",
        "menuType": "C",
        "orderNum": 0,
        "children": []
    },
    {
        "id": 6,
        "parentId": 0,
        "menuName": "关于",
        "path": "/about",
        "component": "views/AboutPage.vue",
        "perms": "about",
        "icon": "#",
        "menuType": "C",
        "orderNum": 5,
        "children": []
    },
    {
        "id": 7,
        "parentId": 0,
        "menuName": "openInfo",
        "path": "/openInfo",
        "component": "views/openInfo/index.vue",
        "perms": "openInfo",
        "icon": "#",
        "menuType": "C",
        "orderNum": 6,
        "children": []
    },
    {
        "id": 8,
        "parentId": 0,
        "menuName": "Video API",
        "path": "/videoApi",
        "component": "views/videoApi/index.vue",
        "perms": "videoApi",
        "icon": "#",
        "menuType": "C",
        "orderNum": 7,
        "children": []
    },
    {
        "id": 13,
        "parentId": 0,
        "menuName": "个人中心",
        "path": "/personal-center",
        "component": "views/personalCenter/index.vue",
        "perms": "personal-center",
        "icon": "#",
        "menuType": "C",
        "orderNum": 13,
        "children": []
    },
    {
        "id": 9,
        "parentId": 0,
        "menuName": "申请成为新石器开发者",
        "path": "/profile",
        "component": "views/profile/index.vue",
        "perms": "profile",
        "icon": "#",
        "menuType": "C",
        "orderNum": 14,
        "children": []
    },
    {
        "id": 20,
        "parentId": 1,
        "menuName": "Cloud API",
        "path": "/homePageCloudApi",
        "component": "views/homePage/homePageCloudApi.vue",
        "perms": "homePageCloudApi",
        "icon": "#",
        "menuType": "C",
        "orderNum": 1,
        "children": []
    },

    {
        "id": 101,
        "parentId": 20,
        "menuName": "概述",
        "path": "/homePageCloudApi",
        "component": "views/homePage/homePageCloudApi.vue",
        "perms": "homePageCloudApi:view",
        "icon": "#",
        "menuType": "C",
        "orderNum": 1,
        "children": []
    },
    {
        "id": 102,
        "parentId": 20,
        "menuName": "文档",
        "path": "/openInfo/product-map",
        "component": "views/openInfo/components/productMap.vue",
        "perms": "openInfo:product-map",
        "icon": "#",
        "menuType": "C",
        "orderNum": 2,
        "children": []
    },
    {
        "id": 100,
        "parentId": 1,
        "menuName": "Video API",
        "path": "/homePageVideoApi",
        "component": "views/homePage/homePageVideoApi.vue",
        "perms": "homePageVideoApi",
        "icon": "#",
        "menuType": "C",
        "orderNum": 2,
        "children": []
    },
    {
        "id": 201,
        "parentId": 100,
        "menuName": "概述",
        "path": "/homePageVideoApi",
        "component": "views/homePage/homePageVideoApi.vue",
        "perms": "homePageVideoApi:view",
        "icon": "#",
        "menuType": "C",
        "orderNum": 1,
        "children": []
    },
    {
        "id": 202,
        "parentId": 100,
        "menuName": "文档",
        "path": "/openInfo/product-map",
        "component": "views/openInfo/components/productMap.vue",
        "perms": "openInfo:product-map",
        "icon": "#",
        "menuType": "C",
        "orderNum": 2,
        "children": []
    },
    {
        "id": 71,
        "parentId": 7,
        "menuName": "版本更新记录",
        "path": "/openInfo/version-record",
        "component": "views/openInfo/components/versionRecord.vue",
        "perms": "openInfo:version-record",
        "icon": "#",
        "menuType": "C",
        "orderNum": 20,
        "children": []
    },

    {
        "id": 78,
        "parentId": 7,
        "menuName": "产品地图",
        "path": "/openInfo/product-map",
        "component": "views/openInfo/components/productMap.vue",
        "perms": "openInfo:product-map",
        "icon": "#",
        "menuType": "C",
        "orderNum": 2,
        "children": []
    },
    {
        "id": 79,
        "parentId": 7,
        "menuName": "开发者注册认证流程",
        "path": "/openInfo/developer-auth-process",
        "component": "views/openInfo/components/developerAuthProcess.vue",
        "perms": "openInfo:developer-auth-process",
        "icon": "#",
        "menuType": "C",
        "orderNum": 3,
        "children": []
    },
    {
        "id": 70,
        "parentId": 7,
        "menuName": "认证及授权",
        "path": "/openInfo/auth",
        "component": "views/openInfo/components/auth/index.vue",
        "perms": "openInfo:auth",
        "icon": "#",
        "menuType": "C",
        "orderNum": 3,
        "children": []
    },
    {
        "id": 701,
        "parentId": 70,
        "menuName": "获取访问凭证",
        "path": "/openInfo/auth/credential",
        "component": "views/openInfo/components/auth/credential.vue",
        "perms": "openInfo:auth:credential",
        "icon": "#",
        "menuType": "C",
        "orderNum": 1,
        "children": [

        ]
    },
    {
        "id": 73,
        "parentId": 7,
        "menuName": "Cloud API",
        "path": "/openInfo/api-introduction",
        "component": "views/openInfo/components/apiIntroduction.vue",
        "perms": "openInfo:api-introduction",
        "icon": "#",
        "menuType": "C",
        "orderNum": 3,
        "children": [

        ]
    },

    {
        "id": 750,
        "parentId": 73,
        "menuName": "接入流程",
        "path": "/openInfo/api-introduction/access-process",
        "component": "views/openInfo/components/api/cloudApiProcess.vue",
        "perms": "openInfo:api-introduction:access-process",
        "icon": "#",
        "menuType": "C",
        "orderNum": 1,
        "children": []
    },
    {
        "id": 751,
        "parentId": 73,
        "menuName": "API列表",
        "path": "/openInfo/api-introduction/api-list",
        "component": "views/openInfo/components/api/apiList.vue",
        "perms": "openInfo:api-introduction:api-list",
        "icon": "#",
        "menuType": "C",
        "orderNum": 2,
        "children": [

        ]
    },
    {
        "id": 732,
        "parentId": 751,
        "menuName": "获取车辆列表",
        "path": "/openInfo/api-introduction/api2",
        "component": "views/openInfo/components/api/api2.vue",
        "perms": "openInfo:api-introduction:api2",
        "icon": "#",
        "menuType": "C",
        "orderNum": 1,
        "children": []
    },
    {
        "id": 733,
        "parentId": 751,
        "menuName": "获取车辆站点信息",
        "path": "/openInfo/api-introduction/api3",
        "component": "views/openInfo/components/api/api3.vue",
        "perms": "openInfo:api-introduction:api3",
        "icon": "#",
        "menuType": "C",
        "orderNum": 2,
        "children": []
    },
    {
        "id": 734,
        "parentId": 751,
        "menuName": "为车辆下发行驶任务",
        "path": "/openInfo/api-introduction/api4",
        "component": "views/openInfo/components/api/api4.vue",
        "perms": "openInfo:api-introduction:api4",
        "icon": "#",
        "menuType": "C",
        "orderNum": 5,
        "children": []
    },
    {
        "id": 745,
        "parentId": 751,
        "menuName": "任务完成回调通知",
        "path": "/openInfo/api-introduction/api20",
        "component": "views/openInfo/components/api/api20.vue",
        "perms": "openInfo:api-introduction:api20",
        "icon": "#",
        "menuType": "C",
        "orderNum": 5,
        "children": []
    },
    {
        "id": 735,
        "parentId": 751,
        "menuName": "获取车辆当前任务详情",
        "path": "/openInfo/api-introduction/api5",
        "component": "views/openInfo/components/api/api5.vue",
        "perms": "openInfo:api-introduction:api5",
        "icon": "#",
        "menuType": "C",
        "orderNum": 11,
        "children": []
    },
    {
        "id": 736,
        "parentId": 751,
        "menuName": "获取车辆已规划路线列表",
        "path": "/openInfo/api-introduction/api6",
        "component": "views/openInfo/components/api/api6.vue",
        "perms": "openInfo:api-introduction:api6",
        "icon": "#",
        "menuType": "C",
        "orderNum": 3,
        "children": []
    },
    {
        "id": 737,
        "parentId": 751,
        "menuName": "为车辆取消行驶任务",
        "path": "/openInfo/api-introduction/api7",
        "component": "views/openInfo/components/api/api7.vue",
        "perms": "openInfo:api-introduction:api7",
        "icon": "#",
        "menuType": "C",
        "orderNum": 6,
        "children": []
    },
    {
        "id": 738,
        "parentId": 751,
        "menuName": "车辆货箱门开启",
        "path": "/openInfo/api-introduction/api8",
        "component": "views/openInfo/components/api/api8.vue",
        "perms": "openInfo:api-introduction:api8",
        "icon": "#",
        "menuType": "C",
        "orderNum": 8,
        "children": []
    },
    {
        "id": 739,
        "parentId": 751,
        "menuName": "车辆开关机",
        "path": "/openInfo/api-introduction/api9",
        "component": "views/openInfo/components/api/api9.vue",
        "perms": "openInfo:api-introduction:api9",
        "icon": "#",
        "menuType": "C",
        "orderNum": 7,
        "children": []
    },
    {
        "id": 740,
        "parentId": 751,
        "menuName": "车辆笼箱开关控制",
        "path": "/openInfo/api-introduction/api10",
        "component": "views/openInfo/components/api/api10.vue",
        "perms": "openInfo:api-introduction:api10",
        "icon": "#",
        "menuType": "C",
        "orderNum": 9,
        "children": []
    },
    {
        "id": 741,
        "parentId": 751,
        "menuName": "获取车辆历史任务详情",
        "path": "/openInfo/api-introduction/api11",
        "component": "views/openInfo/components/api/api11.vue",
        "perms": "openInfo:api-introduction:api11",
        "icon": "#",
        "menuType": "C",
        "orderNum": 12,
        "children": []
    },
    {
        "id": 742,
        "parentId": 751,
        "menuName": "车辆音量大小控制",
        "path": "/openInfo/api-introduction/api12",
        "component": "views/openInfo/components/api/api12.vue",
        "perms": "openInfo:api-introduction:api12",
        "icon": "#",
        "menuType": "C",
        "orderNum": 10,
        "children": []
    },
    {
        "id": 743,
        "parentId": 751,
        "menuName": "获取历史任务总里程和总时长",
        "path": "/openInfo/api-introduction/api13",
        "component": "views/openInfo/components/api/api13.vue",
        "perms": "openInfo:api-introduction:api13",
        "icon": "#",
        "menuType": "C",
        "orderNum": 13,
        "children": []
    },
    {
        "id": 744,
        "parentId": 751,
        "menuName": "批量获取车辆实时信息",
        "path": "/openInfo/api-introduction/api14",
        "component": "views/openInfo/components/api/api14.vue",
        "perms": "openInfo:api-introduction:api14",
        "icon": "#",
        "menuType": "C",
        "orderNum": 4,
        "children": []
    },
    {
        "id": 83,
        "parentId": 7,
        "menuName": "Video API",
        "path": "/openInfo/api-v-introduction",
        "component": "views/openInfo/components/apiIntroduction.vue",
        "perms": "openInfo:api-v-introduction",
        "icon": "#",
        "menuType": "C",
        "orderNum": 3,
        "children": [

        ]
    },
    {
        "id": 830,
        "parentId": 83,
        "menuName": "接入流程",
        "path": "/openInfo/api-v-introduction/process",
        "component": "views/openInfo/components/api-v/videoApiProcess.vue",
        "perms": "openInfo:api-v-introduction:process",
        "icon": "#",
        "menuType": "C",
        "orderNum": 1,
        "children": []
    },
    {
        "id": 831,
        "parentId": 83,
        "menuName": "API列表",
        "path": "/openInfo/api-v-introduction/api-list",
        "component": "views/openInfo/components/api-v/videoApiList.vue",
        "perms": "openInfo:api-v-introduction:api-list",
        "icon": "#",
        "menuType": "C",
        "orderNum": 2,
        "children": [

        ]
    },
    {
        "id": 834,
        "parentId": 831,
        "menuName": "获取可查看的车辆列表",
        "path": "/openInfo/api-v-introduction/api2",
        "component": "views/openInfo/components/api-v/api2.vue",
        "perms": "openInfo:api-v-introduction:api2",
        "icon": "#",
        "menuType": "C",
        "orderNum": 1,
        "children": []
    },
    {
        "id": 835,
        "parentId": 831,
        "menuName": "获取车辆视频通道列表",
        "path": "/openInfo/api-v-introduction/api3",
        "component": "views/openInfo/components/api-v/api3.vue",
        "perms": "openInfo:api-v-introduction:api3",
        "icon": "#",
        "menuType": "C",
        "orderNum": 2,
        "children": []
    },
    {
        "id": 836,
        "parentId": 831,
        "menuName": "获取视频流拉流地址",
        "path": "/openInfo/api-v-introduction/api4",
        "component": "views/openInfo/components/api-v/api4.vue",
        "perms": "openInfo:api-v-introduction:api4",
        "icon": "#",
        "menuType": "C",
        "orderNum": 3,
        "children": []
    },
    {
        "id": 837,
        "parentId": 831,
        "menuName": "关闭车辆视频推流",
        "path": "/openInfo/api-v-introduction/api5",
        "component": "views/openInfo/components/api-v/api5.vue",
        "perms": "openInfo:api-v-introduction:api5",
        "icon": "#",
        "menuType": "C",
        "orderNum": 4,
        "children": []
    },
    {
        "id": 26,
        "parentId": 13,
        "menuName": "菜单详情",
        "path": "/personal-center/profile-detail",
        "component": "views/personalCenter/components/audit/profileDetail.vue",
        "perms": "personal-center:profile-detail",
        "icon": "#",
        "menuType": "C",
        "orderNum": 6,
        "children": []
    },
    {
        "id": 702,
        "parentId": 7,
        "menuName": "常见问题",
        "path": "/openInfo/FAQ",
        "component": "views/openInfo/components/auth/FAQIntegration.vue",
        "perms": "openInfo:FAQ",
        "icon": "#",
        "menuType": "C",
        "orderNum": 5,
        "children": [

        ]
    },
    {
        "id": 76,
        "parentId": 7,
        "menuName": "在线调试",
        "path": "/openInfo/online-debug",
        "component": "views/openInfo/components/onlineDebug.vue",
        "perms": "openInfo:online-debug",
        "icon": "#",
        "menuType": "C",
        "orderNum": 6,
        "children": []
    },
    {
        "id": 16,
        "parentId": 13,
        "menuName": "开发者申请列表",
        "path": "/personal-center/audit-manage",
        "component": "views/personalCenter/components/auditManage.vue",
        "perms": "audit:list",
        "icon": "#",
        "menuType": "C",
        "orderNum": 2,
        "children": []
    },
    {
        "id": 14,
        "parentId": 13,
        "menuName": "应用管理",
        "path": "/personal-center/app-manage",
        "component": "views/personalCenter/components/appManage.vue",
        "perms": "personal-center:app-manage",
        "icon": "#",
        "menuType": "C",
        "orderNum": 11,
        "children": []
    },
    {
        "id": 15,
        "parentId": 14,
        "menuName": "我的回调配置",
        "path": "/personal-center/app-manage/callback",
        "component": "views/personalCenter/components/callback.vue",
        "perms": "personal-center:app-manage:callback",
        "icon": "#",
        "menuType": "C",
        "orderNum": 1,
        "visible": 0,
        "children": []
    },
    {
        "id": 11,
        "parentId": 13,
        "menuName": "信息管理",
        "path": "/personal-center/info-manage",
        "component": "views/personalCenter/components/infoManage.vue",
        "perms": "personal-center:info-manage",
        "icon": "#",
        "menuType": "C",
        "orderNum": 14,
        "children": [],
    }
]

export default notLogRouter